{
  "$id": "wealthlane://forms/department",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../department.domain.json",
  "properties": {
    "name": {
      "$ref": "module://department#properties/name",
      "required": true
    },
    "description": {
      "$ref": "module://department#properties/description"
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_DEPARTMENT",
      "refreshEntities": [
        "Department"
      ],
      "invalidateQueries": [
        "getDepartmentListWithPagination"
      ]
    }
  },
  "modes": {
    "create": {
      "dataSource": {
        "submit": {
          "successMessage": "Department added."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_DEPARTMENT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        },
        "submit": {
          "successMessage": "Department edited."
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_DEPARTMENT_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}